import { AlpineComponent } from "alpinejs";
import htmx from "htmx.org";

type FilterComponent = AlpineComponent<{
	onFilterAccordion: (inputId: string) => void;
	onFilterRemove: (filterElement: HTMLElement, value: string) => void;
	onClearAllFilters: () => void;
}>;

export default (formElement: HTMLElement): FilterComponent => {
	const parent = formElement.parentElement;
	const form = parent?.querySelector("form");

	return {
		onFilterAccordion(inputId: string) {
			const inputNode = document.querySelector<HTMLInputElement>(`#${inputId}`);
			if (!inputNode) {
				return;
			}
			inputNode.disabled = !inputNode.disabled;
		},
		onFilterRemove(filterElement: HTMLElement, value: string) {
			const root = filterElement.closest("li");
			if (root != null) {
				root.remove();
			}
			const formFilterElement = form?.querySelector<HTMLInputElement>(`input[type='checkbox'][value='${value}']`);
			if (formFilterElement != null) {
				formFilterElement.checked = false;
				htmx.trigger(formFilterElement, "change");
			}
		},
		onClearAllFilters() {
			if (form == null) {
				return;
			}
			const formFilterElements = form?.querySelectorAll<HTMLInputElement>(`input[type='checkbox']`);
			for (const formFilterElement of formFilterElements) {
				formFilterElement.checked = false;
			}
			const selectedFilters = form?.querySelectorAll<HTMLLIElement>("#selected-filters li");
			for (const selectedFilter of selectedFilters) {
				selectedFilter.remove();
			}
			htmx.trigger(form, "submit");
		},
	};
};
